<template>
   <div class="mainC">
        <ul class="list-group MobileHide">
            <div v-if="cookiesObject.token">
             <li class="list-group-item" style="background-image: linear-gradient(to right, #9b7b23, #dacb68); color: white; line-height: 7px;" v-if="findCommonElements()">{{ $t('LanguageEn.myTeamsMatches') }}</li>
            <div v-for="fav in favs" :key="fav.id" style="width: 100%;">
                <div v-for="gamee in games" :key="gamee.id">
                    <li class="list-group-item game" v-if="fav.id == gamee.team2.id || fav.id == gamee.team1.id">
                        <div class="row">
                        <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: gamee.id }}">
                        <div class="row">
                        <div class="col-1 bodyElement">
                        <p v-if="gamee.matchStatus.name == 'FT'">{{gamee.matchStatus.name}}</p>
                        <p v-else-if="gamee.matchStatus.name == 'FT_PEN'">FT</p>
                        <p v-else-if="gamee.matchStatus.name == 'BREAK'">BR</p>
                        <p v-else-if="gamee.matchStatus.name == 'POSTP'">PST</p>
                        <p v-else-if="gamee.matchStatus.name == 'NS'">{{gamee.matchTime.slice(11,16)}}</p>    
                        <p v-else-if="gamee.matchStatus.name == 'TBA'">TB</p>    
                        <p v-else-if="gamee.matchStatus.name == 'AWARDED'">AWR</p>     
                        <p v-else-if="gamee.matchStatus.name == 'LIVE'">{{calculateMinutes(gamee.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
                        <p v-else-if="gamee.matchStatus.name == 'CANCL'">CAN</p>  
                        <p v-else>{{gamee.matchStatus.name}}</p>  
                        </div>
                        <div class="col bodyElement">
                            {{gamee.team1.name}}
                        </div>
                        <div class="col-2 bodyElement" v-if="gamee.matchStatus.name == 'NS' || gamee.matchStatus.name == 'POSTP' || gamee.matchStatus.name == 'CANCL'" style="font-weight: 600; margin-top: -5px;">
                            <img :src="teamLogo + gamee.team1.id" alt="" style="width: 20px;" > - <img :src="teamLogo + gamee.team2.id" alt="" style="width: 20px;" >
                        </div>
                        <div class="col-2 bodyElement" v-else>
                            {{gamee.currentScore}}
                        </div>
                        <div class="col bodyElement">
                            {{gamee.team2.name}}
                        </div>
                            </div>
                        </router-link>
                         <div class="col-1 bodyElement">
                        <div>
                        <b-btn v-if="favsTe.some(fav => fav.id === gamee.id)" v-on:click="removeFavorite({value: gamee.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: gamee.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
                        </div>
                        </div>
                    </div>
                    </li>  
                </div>
            </div>
            </div>
            <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem; margin: auto; margin-top: 20px; margin-bottom: 20px;" v-if="spinning"></b-spinner>
            <div v-for="(tourId, j) in tourOrder" :key="j">
                    <li class="list-group-item" style="background: #d6d6d6; color: black; line-height: 7px;" v-if="cookiesObject.token"> 
                        <b-btn v-if="favsT.some(fav => fav.id === tournaments[tourId][0].tournament.id)" v-on:click="removeFavorite({value: tournaments[tourId][0].tournament.id , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: tournaments[tourId][0].tournament.id , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn>           
                        <router-link id="router-link-league" :to="{ name: 'LeaguePageNav', params: { leagueId: tournaments[tourId][0].tournament.id } }"> 
                            <img v-if="tournaments[tourId][0].tournament.category.icon == null" src="@/assets/int.png" style="width: 17px; margin-top: -2px;" alt=""/>
                            <img v-else :src="leagueLogo + tournaments[tourId][0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                            {{tournaments[tourId][0].tournament.name}} 
                            <span style="float: right;">{{woolo}}</span>
                        </router-link>
                    </li>
                    <li class="list-group-item" style="background: #d6d6d6; color: black; line-height: 7px;" v-else-if="!cookiesObject.token" data-toggle="modal" data-target="#exampleModal"> 
                            <b-btn style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn>           
                            <img v-if="tournaments[tourId][0].tournament.category.icon == null" src="@/assets/int.png" style="width: 17px; margin-top: -2px;" alt=""/>
                            <img v-else :src="leagueLogo + tournaments[tourId][0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                            <span style="cursor: pointer;">{{tournaments[tourId][0].tournament.name}}</span> 
                            <span style="float: right;">{{woolo}}</span>
                    </li>
            <div v-for="(game, i) in tournaments[tourId]" :key="i"> 
            <li class="list-group-item game" v-if="cookiesObject.token">
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id }}">
            <div class="row">
            <div class="col-1 bodyElement">
              <p v-if="game.matchStatus.name == 'FT'">{{game.matchStatus.name}}</p>
              <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.matchStatus.name == 'NS'">{{game.matchTime.slice(11,16)}}</p>  
              <p v-else-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
              <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>  
              <p v-else>{{game.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
                {{game.team1.name.slice(0,26)}}
            </div>
            <div class="col-2 bodyElement" v-if="game.matchStatus.name == 'NS' || game.matchStatus.name == 'POSTP' || game.matchStatus.name == 'CANCL'" style="font-weight: 600; margin-top: -5px;">
                <img :src="teamLogo + game.team1.id" alt="" style="width: 20px;"> - <img :src="teamLogo + game.team2.id" alt="" style="width: 20px;" >
            </div>
            <div class="col-2 bodyElement" v-else>
                {{game.currentScore}}
            </div>
            <div class="col bodyElement">
                {{game.team2.name.slice(0,26)}}
            </div>
                </div>
            </router-link>
            <div class="col-1 bodyElement">
            <div v-if="!cookiesObject.token">
            <b-btn data-toggle="modal" data-target="#exampleModal" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            <div v-else>
            <b-btn v-if="favsTe.some(fav => fav.id === game.id)" v-on:click="removeFavorite({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            </div>
        </div>
            </li>  
            <li class="list-group-item game" v-else data-toggle="modal" data-target="#exampleModal"  style="cursor: pointer;"> 
            <div class="row">
            <div class="col-1 bodyElement">
              <p v-if="game.matchStatus.name == 'FT'">{{game.matchStatus.name}}</p>
              <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.matchStatus.name == 'NS'">{{game.matchTime.slice(11,16)}}</p>   
              <p v-else-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
              <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>  
              <p v-else>{{game.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
                {{game.team1.name.slice(0,26)}}
            </div>
            <div class="col-2 bodyElement" v-if="game.matchStatus.name == 'NS' || game.matchStatus.name == 'POSTP' || game.matchStatus.name == 'CANCL'" style="font-weight: 600; margin-top: -5px;">
                <img :src="teamLogo + game.team1.id" alt="" style="width: 20px;" > - <img :src="teamLogo + game.team2.id" alt="" style="width: 20px;" >
            </div>
            <div class="col-2 bodyElement" v-else>
                {{game.currentScore}}
            </div>
            <div class="col bodyElement">
                {{game.team2.name.slice(0,26)}}
            </div>
            <div class="col-1 bodyElement">
            <div>
            <b-btn style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            </div>
                </div>
            </li> 
            </div>   
            </div>   
        </ul>
        <ul class="list-group MobileShow">
              <div v-if="cookiesObject.token">
            <li class="list-group-item" style="background-image: linear-gradient(to right, #9b7b23, #dacb68); color: black; line-height: 7px;" v-if="findCommonElements()">{{ $t('LanguageEn.myTeamsMatches') }}</li>
            <div v-for="fav in favs" :key="fav.id" style="width: 100%;">
                <div v-for="gamee in games" :key="gamee.id">
                    <li class="list-group-item game" v-if="fav.id == gamee.team2.id || fav.id == gamee.team1.id">
                    <div class="row">
                    <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: gamee.id }}">
                    <div class="row">
                    <div class="col-1 bodyElement shuf" style="margin-top: 10px;">
                    <p v-if="gamee.matchStatus.name == 'FT'">{{gamee.matchStatus.name}}</p>
                    <p v-else-if="gamee.matchStatus.name == 'FT_PEN'">FT</p>
                    <p v-else-if="gamee.matchStatus.name == 'BREAK'">BR</p>
                    <p v-else-if="gamee.matchStatus.name == 'POSTP'">PST</p>
                    <p v-else-if="gamee.matchStatus.name == 'NS'">{{gamee.matchTime.slice(11,16)}}</p>    
                    <p v-else-if="gamee.matchStatus.name == 'TBA'">TB</p>    
                    <p v-else-if="gamee.matchStatus.name == 'AWARDED'">AWR</p>     
                    <p v-else-if="gamee.matchStatus.name == 'LIVE'">{{calculateMinutes(gamee.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
                    <p v-else-if="gamee.matchStatus.name == 'CANCL'">CAN</p>  
                    <p v-else>{{gamee.matchStatus.name}}</p>  
                    </div>
                    <div class="col" style="text-align: left; font-size: 14px; margin-top: 4px;">
                    <div class="bodyElement" style="margin-bottom: 10px;">
                        {{gamee.team1.name}}
                    </div>
                    <div class="bodyElement">
                        {{gamee.team2.name}}
                    </div>
                    </div>
                    <div class="col-1" v-if="gamee.matchStatus.name == 'NS'" style="font-weight: 900; margin-top: 4px;">
                        <div style="margin-bottom: 15px;">
                        ? 
                        </div>
                        <div>
                        ?
                        </div>
                    </div>
                    <div class="col-1" v-else style="margin-top: 4px;">
                        <div style="margin-bottom: 15px;">
                    {{gamee.currentScore.slice(0,1)}} 
                        </div>
                        <div>
                    {{gamee.currentScore.slice(2,3)}}
                        </div>
                    </div>
                        </div>
                    </router-link>
                    <div class="col-1 bodyElement" style="margin-top: 4px;">
                    <div>
                    <b-btn v-if="favsTe.some(fav => fav.id === gamee.id)" v-on:click="removeFavorite({value: gamee.id , type: match})" style="float: right; background: none; border: none;"> <img src="@/assets/blackStar.png" style="width: 17px; margin-top: -16px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: gamee.id , type: match})" style="float: right; background: none; border: none;"> <img src="@/assets/favorite.png" style="width: 17px; margin-top: -16px; margin-left: -10px;" alt=""> </b-btn>           
                    </div>    
                    </div>
                </div>
            </li>
                </div>
            </div>
            </div>
            <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem; margin: auto; margin-top: 20px; margin-bottom: 20px;" v-if="spinning"></b-spinner>
            <div v-for="(tourId, j) in tourOrder" :key="j">
                    <li class="list-group-item" style="background: #d6d6d6; color: black; line-height: 7px;" v-if="cookiesObject.token"> 
                        <b-btn v-if="favsT.some(fav => fav.id === tournaments[tourId][0].tournament.id)" v-on:click="removeFavorite({value: tournaments[tourId][0].tournament.id , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: tournaments[tourId][0].tournament.id , type: tournament})" style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn>           
                        <router-link id="router-link-league" :to="{ name: 'LeaguePageNav', params: { leagueId: tournaments[tourId][0].tournament.id } }"> 
                            <img v-if="tournaments[tourId][0].tournament.category.icon == null" src="@/assets/int.png" style="width: 17px; margin-right: 0px; margin-top: -2px;" alt=""/>
                            <img v-else :src="leagueLogo + tournaments[tourId][0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                            {{tournaments[tourId][0].tournament.name}} 
                            <span style="float: right;">{{woolo}}</span>
                        </router-link>
                    </li>
                      <li class="list-group-item" style="background: #d6d6d6; color: black; line-height: 7px;" v-else-if="!cookiesObject.token" v-b-modal.modal-multi-1> 
                            <b-btn style="background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -32px; margin-left: -10px;" alt=""> </b-btn>           
                            <img v-if="tournaments[tourId][0].tournament.category.icon == null" src="@/assets/int.png" style="width: 17px; margin-right: 0px; margin-top: -2px;" alt=""/>
                            <img v-else :src="leagueLogo + tournaments[tourId][0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                            {{tournaments[tourId][0].tournament.name}} 
                            <span style="float: right;">{{woolo}}</span>
                      </li>
            <div v-for="(game, i) in tournaments[tourId]" :key="i"> 
            <li class="list-group-item game" v-if="cookiesObject.token">
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id }}">
            <div class="row">
            <div class="col-1 bodyElement shuf" style="margin-top: 10px;">
              <p v-if="game.matchStatus.name == 'FT'">{{game.matchStatus.name}}</p>
              <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
              <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.matchStatus.name == 'NS'">{{game.matchTime.slice(11,16)}}</p>    
              <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
              <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>  
              <p v-else>{{game.matchStatus.name}}</p>  
              </div>
              <div class="col" style="text-align: left; font-size: 14px; margin-top: 4px;">
            <div class="bodyElement" style="margin-bottom: 10px;">
                {{game.team1.name}}
            </div>
            <div class="bodyElement">
                {{game.team2.name}}
            </div>
            </div>
             <div class="col-1" v-if="game.matchStatus.name == 'NS'" style="font-weight: 900; margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
                ? 
                </div>
                 <div>
                ?
                 </div>
            </div>
            <div class="col-1" v-else style="margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
            {{game.currentScore.slice(0,1)}} 
                </div>
                 <div>
            {{game.currentScore.slice(2,3)}}
                 </div>
            </div>
                </div>
            </router-link>
            <div class="col-1 bodyElement" style="margin-top: 4px;">
             <div>
            <b-btn v-if="favsTe.some(fav => fav.id === game.id)" v-on:click="removeFavorite({value: game.id , type: match})" style="float: right; background: none; border: none;"> <img src="@/assets/blackStar.png" style="width: 17px; margin-top: -16px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: game.id , type: match})" style="float: right; background: none; border: none;"> <img src="@/assets/favorite.png" style="width: 17px; margin-top: -16px; margin-left: -10px;" alt=""> </b-btn>           
             </div>    
            </div>
        </div>
            </li> 
            <li class="list-group-item game" v-else v-b-modal.modal-multi-1>
            <div class="row">
            <div class="col-1 bodyElement shuf" style="margin-top: 10px;">
              <p v-if="game.matchStatus.name == 'FT'">{{game.matchStatus.name}}</p>
              <p v-else-if="game.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.matchStatus.name == 'BREAK'">BR</p>
              <p v-else-if="game.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.matchStatus.name == 'NS'">{{game.matchTime.slice(11,16)}}</p>    
              <p v-else-if="game.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>      
              <p v-else-if="game.matchStatus.name == 'CANCL'">CAN</p>  
              <p v-else>{{game.matchStatus.name}}</p>  
              </div>
              <div class="col" style="text-align: left; font-size: 14px; margin-top: 4px;">
            <div class="bodyElement" style="margin-bottom: 10px;">
                {{game.team1.name}}
            </div>
            <div class="bodyElement">
                {{game.team2.name}}
            </div>
            </div>
             <div class="col-1" v-if="game.matchStatus.name == 'NS'" style="font-weight: 900; margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
                ? 
                </div>
                 <div>
                ?
                 </div>
            </div>
            <div class="col-1" v-else style="margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
            {{game.currentScore.slice(0,1)}} 
                </div>
                 <div>
            {{game.currentScore.slice(2,3)}}
                 </div>
            </div>
            <div class="col-1 bodyElement" style="margin-top: 4px;">
            <div>
            <b-btn v-b-modal.modal-multi-1 style="float: right; background: none; border: none;"> <img src="@/assets/favorite.png" style="width: 17px; margin-top: -16px; margin-left: -10px;" alt=""> </b-btn>           
            </div>   
            </div>
                </div>
            </li> 
            </div>   
            </div>   
        </ul>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';


export default {
  name: 'Finished',
  data(){
      return{
          games: [],
          value: '',
          spinning: '',
          cookiesObject: '',
          leagueLogo: 'https://sportapi.zuniac.com/category/logo/',
          teamLogo: 'https://sportapi.zuniac.com/team/logo/',
          dateS: '', 
          match: 'match',
          tournaments: {},
          tourOrder: [],
          woolo: '',
          tournament: 'tournament',
      }
  },
  async mounted(){

    this.dateS = this.$route.params.dateS;

    if (this.dateS == this.getDate1()) {
        this.$router.push({ name: 'Today' })         
    }
      
    this.spinning = true;
    
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;  
    
    var offset = new Date().getTimezoneOffset();

    if (cookiesObject.token) {
        
    const res = await fetch(this.httpReq + '/sport/matches?date=' + this.dateS + '&langId='+ this.cookiesObject.langId +'&portalId=' + this.cookiesObject.portalId + '&sportId=1&timezone=%2B'+ offset/-60 +'%3A00&token=' + cookiesObject.token);
    const data = await res.json();
    const games = data.matches;
    this.games = games;

    if (data.code == 200) {
       //everything is okay
    }
    else if (data.code == 401) {
      alert('Logged from another browser, try to re sign!');
         document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(data.code == 404){
        alert('Token is not valid and portal id not provided')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    else if(data.code == 500){
        alert('Server side error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else {
        alert('service error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }

    } else {

    const res = await fetch(this.httpReq + '/sport/matches?date=' + this.dateS + '&langId='+ this.cookiesObject.langId +'&portalId=' + this.cookiesObject.portalId + '&sportId=1&timezone=%2B'+ offset/-60 +'%3A00');
    const data = await res.json();
    const games = data.matches;
    this.games = games;   
    }

    this.headerDate();

     const tournaments = {};
    const tourOrder = [];
    
    this.games.forEach((e) => {
        const tourid = e.tournament.id;

        if(typeof tournaments[tourid] === 'undefined') {
            tournaments[tourid] = [];
            tourOrder.push(tourid);
        }

        tournaments[tourid].push(e);
    });
    
    // this.games = games;
    this.tournaments = tournaments;
    this.tourOrder = tourOrder;

    this.findCommonElements();

    
    this.spinning = false;

  },


    methods:{
      ...mapActions(["removeFavorite", "addToFavorites"]),
      headerDate(){
            var dateObj = new Date(this.dateS);
            var month = dateObj.getUTCMonth(); 

            this.woolo = this.monthNames[month] + ' ' +this.dateS.slice(8,10);
         },
         

         findCommonElements() { 
        let result = this.games.map(a => a.team1.id);
        let result1 = this.games.map(a => a.team2.id);

        var finalarr = result.concat(result1); 

        let result2 = this.favs.map(a => a.id);

        const found = result2.some(r=> finalarr.includes(r))

        return found;

        },  
        getDate1(){
        var dt = new Date();
        dt.setDate( dt.getDate() );
        var fdDate = dt.getDate();
        var fdMonth =(dt.getMonth() + 1);
        var fdYear = dt.getFullYear();   

        if (fdMonth.toString().length == 1) {
                  fdMonth = '0' + fdMonth; 
                } 
                if (fdDate.toString().length == 1) {
                  fdDate = '0' + fdDate; 
                } 
         
        var fd =  fdYear + '-' + fdMonth + '-' +fdDate;
        return fd;
    },  
    calculateMinutes(value){
        if (value == null) {
            return 'LIVE';
        } else{

        var startDate = new Date(value.replace(' ', 'T'));
        var endDate   =  Date.now();
        var difference = ((endDate - startDate) / 1000) / 60;

        if (difference < 0) {
            difference = difference + 240;
        }

        return parseInt(difference);
        }
         },
    },  
  components: {
  },
  props: {
    
  },
  computed: { 
      ...mapGetters(['favsTe', 'favs', 'favsT','httpReq']),
 monthNames(){
       return [this.$t('LanguageEn.month1'), this.$t('LanguageEn.month2'), this.$t('LanguageEn.month3'), this.$t('LanguageEn.month4'), this.$t('LanguageEn.month5'), this.$t('LanguageEn.month6'),this.$t('LanguageEn.month7'), this.$t('LanguageEn.month8'), this.$t('LanguageEn.month9'), this.$t('LanguageEn.month10'), this.$t('LanguageEn.month11'), this.$t('LanguageEn.month12')]
    },
        },

  watch: {
  },
}

</script>

<style scoped>
.mainC{
    margin-top: 2px;
}
#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}
#router-link-league{
    color: black;
    text-decoration: none;
}

li{
   line-height:5px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: white;
}

.bodyElement{
    padding: 0;
    height: 8px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}


@media only screen and (max-width: 770px) {
  .bodyElement{
    border-right: 1px solid #efefef;
    padding: 0;
    height: 8px;
    }
    .MobileHide {
    display: none;
  }
}
</style>
